'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _rpNavigation = require('rp-navigation');

var _rpMqBreakpoints = require('rp-mq-breakpoints');

var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Class works with navigation and using navigation component functionality */
var Navigation = function () {

    /**
     * Setting Cookie Policy by initializing
     */
    function Navigation() {
        (0, _classCallCheck3.default)(this, Navigation);

        this._props = {
            /**
             * {bool} Indicator for current breakpoint status: is Narrow or X-Narrow or nor
             */
            isLastBreakpointNarrow: false,
            /**
             * {object} Object from navigation component to get data about last active menu point
             */
            lastActiveItem: _rpNavigation.secondary.getActiveItem()
        };
    }

    /**
     * Subscribes on breakpoint change event and triggers it once
     * @param {string} title - Title of submenu link with arrow
     */


    (0, _createClass3.default)(Navigation, [{
        key: 'handleBreakpointChange',
        value: function handleBreakpointChange(title) {
            this._props.title = title;
            this.eventTrigger(this._props.title);

            var context = this;
            $(window).on('rpBreakpointsSwitch', function (event) {
                context.eventTrigger(context._props.title, event);
            });
        }

        /**
         * Actions check changing breakpoint to narrow and ex-narrow or vise versa and show/hide additional title to arrow
         * @param {string} title - Title of submenu link with arrow
         * @param {object} event - Event object from breakpointListener
         */

    }, {
        key: 'eventTrigger',
        value: function eventTrigger(title) {
            var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var code = event ? event.detail.breakpoint.code : _rpMqBreakpoints2.default.current().code;
            if (!this._props.isLastBreakpointNarrow && (this._props.isLastBreakpointNarrow = this.isNarrowOrXNarrow(code))) {
                _rpNavigation.secondary.addItem(title, '#', 1);
                var menuPoint = _rpNavigation.secondary.getItemByPosition(1);
                _rpNavigation.secondary.setActiveItem(menuPoint);
                _rpNavigation.secondary.render();
                $('#secondaryNav').find('.ui-link_marked').parent().remove();
            } else if (this._props.isLastBreakpointNarrow && !(this._props.isLastBreakpointNarrow = this.isNarrowOrXNarrow(code))) {
                _rpNavigation.secondary.removeItem(_rpNavigation.secondary.getActiveItem());
                _rpNavigation.secondary.setActiveItem(this._props.lastActiveItem);
                _rpNavigation.secondary.render();
            }
        }

        /**
         * Get the answer for a question - is that code narrow or ex-narrow?
         * @param {string} code - List of possible codes: [n, xn, m, w, xw]
         * @returns {boolean}
         */

    }, {
        key: 'isNarrowOrXNarrow',
        value: function isNarrowOrXNarrow(code) {
            return code === 'n' || code === 'xn' ? true : false;
        }
    }]);
    return Navigation;
}();

exports.default = Navigation;
;


//////////////////
// WEBPACK FOOTER
// ./public/js/navigation.js
// module id = 631
// module chunks = 0